import { render } from "./OutstandingRequests.vue?vue&type=template&id=072b747e&scoped=true"
import script from "./OutstandingRequests.vue?vue&type=script&lang=js"
export * from "./OutstandingRequests.vue?vue&type=script&lang=js"

import "./OutstandingRequests.vue?vue&type=style&index=0&id=072b747e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072b747e"]])

export default __exports__